// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"508542a1408d62b09d61","293":"dfaa5bd2af69359f27f7","518":"ca7779073777aa941a2f","779":"9e2c21e3cd4e49c0155c"}[chunkId] + ".js";
};